export const bangladeshDivisions = [
  'Barishal',
  'Chattogram',
  'Dhaka',
  'Khulna',
  'Mymensingh',
  'Rajshahi',
  'Rangpur',
  'Sylhet'
];

export const divisionsToDistricts = {
  'Barishal': ['Barguna', 'Barishal', 'Bhola', 'Jhalokati', 'Patuakhali', 'Pirojpur'],
  'Chattogram': ['Bandarban', 'Brahmanbaria', 'Chandpur', 'Chattogram', 'Cumilla', 'Cox\'s Bazar', 'Feni', 'Khagrachhari', 'Lakshmipur', 'Noakhali', 'Rangamati'],
  'Dhaka': ['Dhaka', 'Faridpur', 'Gazipur', 'Gopalganj', 'Kishoreganj', 'Madaripur', 'Manikganj', 'Munshiganj', 'Narayanganj', 'Narsingdi', 'Rajbari', 'Shariatpur', 'Tangail'],
  'Khulna': ['Bagerhat', 'Chuadanga', 'Jashore', 'Jhenaidah', 'Khulna', 'Kustia', 'Magura', 'Meherpur', 'Narail', 'Satkhira'],
  'Mymensingh': ['Jamalpur', 'Mymensingh', 'Netrokona', 'Sherpur'],
  'Rajshahi': ['Bagura', 'Chapainawabganj', 'Joypurhat', 'Naogaon', 'Natore', 'Pabna', 'Rajshahi', 'Sirajganj'],
  'Rangpur': ['Dinajpur', 'Gaibandha', 'Kurigram', 'Lalmonirhat', 'Nilphamari', 'Panchagarh', 'Rangpur', 'Thakurgaon'],
  'Sylhet': ['Habiganj', 'Moulvibazar', 'Sunamganj', 'Sylhet']
};

export const districtToConstituencies = {
  // Barishal Division
  'Barguna': ['Barguna-1', 'Barguna-2'],
  'Barishal': ['Barishal-1', 'Barishal-2', 'Barishal-3', 'Barishal-4', 'Barishal-5', 'Barishal-6'],
  'Bhola': ['Bhola-1', 'Bhola-2', 'Bhola-3', 'Bhola-4'],
  'Jhalokati': ['Jhalokati-1', 'Jhalokati-2'],
  'Patuakhali': ['Patuakhali-1', 'Patuakhali-2', 'Patuakhali-3', 'Patuakhali-4'],
  'Pirojpur': ['Pirojpur-1', 'Pirojpur-2', 'Pirojpur-3'],
  // Chattogram Division
  'Bandarban': ['Bandarban'],
  'Brahmanbaria': ['Brahmanbaria-1', 'Brahmanbaria-2', 'Brahmanbaria-3', 'Brahmanbaria-4', 'Brahmanbaria-5', 'Brahmanbaria-6'],
  'Chandpur': ['Chandpur-1', 'Chandpur-2', 'Chandpur-3', 'Chandpur-4', 'Chandpur-5'],
  'Chattogram': ['Chittagong-1', 'Chittagong-2', 'Chittagong-3', 'Chittagong-4', 'Chittagong-5', 'Chittagong-6', 'Chittagong-7', 'Chittagong-8', 'Chittagong-9', 'Chittagong-10', 'Chittagong-11', 'Chittagong-12', 'Chittagong-13', 'Chittagong-14', 'Chittagong-15', 'Chittagong-16'],
  'Cumilla': ['Comilla-1', 'Comilla-2', 'Comilla-3', 'Comilla-4', 'Comilla-5', 'Comilla-6', 'Comilla-7', 'Comilla-8', 'Comilla-9', 'Comilla-10', 'Comilla-11'],
  'Cox\'s Bazar': ['Cox\'s Bazar-1', 'Cox\'s Bazar-2', 'Cox\'s Bazar-3', 'Cox\'s Bazar-4'],
  'Feni': ['Feni-1', 'Feni-2', 'Feni-3'],
  'Khagrachhari': ['Khagrachhari'],
  'Lakshmipur': ['Lakshmipur-1', 'Lakshmipur-2', 'Lakshmipur-3', 'Lakshmipur-4'],
  'Noakhali': ['Noakhali-1', 'Noakhali-2', 'Noakhali-3', 'Noakhali-4', 'Noakhali-5', 'Noakhali-6'],
  'Rangamati': ['Rangamati'],
  // Dhaka Division
  'Dhaka': ['Dhaka-1', 'Dhaka-2', 'Dhaka-3', 'Dhaka-4', 'Dhaka-5', 'Dhaka-6', 'Dhaka-7', 'Dhaka-8', 'Dhaka-9', 'Dhaka-10', 'Dhaka-11', 'Dhaka-12', 'Dhaka-13', 'Dhaka-14', 'Dhaka-15', 'Dhaka-16', 'Dhaka-17', 'Dhaka-18', 'Dhaka-19', 'Dhaka-20'],
  'Faridpur': ['Faridpur-1', 'Faridpur-2', 'Faridpur-3', 'Faridpur-4'],
  'Gazipur': ['Gazipur-1', 'Gazipur-2', 'Gazipur-3', 'Gazipur-4', 'Gazipur-5'],
  'Gopalganj': ['Gopalganj-1', 'Gopalganj-2', 'Gopalganj-3'],
  'Kishoreganj': ['Kishoreganj-1', 'Kishoreganj-2', 'Kishoreganj-3', 'Kishoreganj-4', 'Kishoreganj-5', 'Kishoreganj-6'],
  'Madaripur': ['Madaripur-1', 'Madaripur-2', 'Madaripur-3'],
  'Manikganj': ['Manikganj-1', 'Manikganj-2', 'Manikganj-3'],
  'Munshiganj': ['Munshiganj-1', 'Munshiganj-2', 'Munshiganj-3'],
  'Narayanganj': ['Narayanganj-1', 'Narayanganj-2', 'Narayanganj-3', 'Narayanganj-4', 'Narayanganj-5'],
  'Narsingdi': ['Narsingdi-1', 'Narsingdi-2', 'Narsingdi-3', 'Narsingdi-4', 'Narsingdi-5'],
  'Rajbari': ['Rajbari-1', 'Rajbari-2'],
  'Shariatpur': ['Shariatpur-1', 'Shariatpur-2', 'Shariatpur-3'],
  'Tangail': ['Tangail-1', 'Tangail-2', 'Tangail-3', 'Tangail-4', 'Tangail-5', 'Tangail-6', 'Tangail-7', 'Tangail-8'],
  // Khulna Division
  'Bagerhat': ['Bagerhat-1', 'Bagerhat-2', 'Bagerhat-3', 'Bagerhat-4'],
  'Chuadanga': ['Chuadanga-1', 'Chuadanga-2'],
  'Jashore': ['Jashore-1', 'Jashore-2', 'Jashore-3', 'Jashore-4', 'Jashore-5', 'Jashore-6'],
  'Jhenaidah': ['Jhenaidah-1', 'Jhenaidah-2', 'Jhenaidah-3', 'Jhenaidah-4'],
  'Khulna': ['Khulna-1', 'Khulna-2', 'Khulna-3', 'Khulna-4', 'Khulna-5', 'Khulna-6'],
  'Kustia': ['Kustia-1', 'Kustia-2', 'Kustia-3', 'Kustia-4'],
  'Magura': ['Magura-1', 'Magura-2'],
  'Meherpur': ['Meherpur-1', 'Meherpur-2'],
  'Narail': ['Narail-1', 'Narail-2'],
  'Satkhira': ['Satkhira-1', 'Satkhira-2', 'Satkhira-3', 'Satkhira-4'],
  // Mymensingh Division
  'Mymensingh': ['Mymensingh-1', 'Mymensingh-2', 'Mymensingh-3', 'Mymensingh-4', 'Mymensingh-5', 'Mymensingh-6', 'Mymensingh-7', 'Mymensingh-8', 'Mymensingh-9', 'Mymensingh-10', 'Mymensingh-11'],
  'Netrokona': ['Netrokona-1', 'Netrokona-2', 'Netrokona-3', 'Netrokona-4', 'Netrokona-5'],
  'Jamalpur': ['Jamalpur-1', 'Jamalpur-2', 'Jamalpur-3', 'Jamalpur-4', 'Jamalpur-5'],
  'Sherpur': ['Sherpur-1', 'Sherpur-2', 'Sherpur-3'],
  // Rajshahi Division
  'Bagura': ['Bagura-1', 'Bagura-2', 'Bagura-3', 'Bagura-4', 'Bagura-5', 'Bagura-6', 'Bagura-7'],
  'Chapainawabganj': ['Chapainawabganj-1', 'Chapainawabganj-2', 'Chapainawabganj-3'],
  'Joypurhat': ['Joypurhat-1', 'Joypurhat-2'],
  'Naogaon': ['Naogaon-1', 'Naogaon-2', 'Naogaon-3', 'Naogaon-4', 'Naogaon-5', 'Naogaon-6'],
  'Natore': ['Natore-1', 'Natore-2', 'Natore-3', 'Natore-4'],
  'Pabna': ['Pabna-1', 'Pabna-2', 'Pabna-3', 'Pabna-4', 'Pabna-5'],
  'Rajshahi': ['Rajshahi-1', 'Rajshahi-2', 'Rajshahi-3', 'Rajshahi-4', 'Rajshahi-5', 'Rajshahi-6'],
  'Sirajganj': ['Sirajganj-1', 'Sirajganj-2', 'Sirajganj-3', 'Sirajganj-4', 'Sirajganj-5', 'Sirajganj-6'],
  // Rangpur Division
  'Dinajpur': ['Dinajpur-1', 'Dinajpur-2', 'Dinajpur-3', 'Dinajpur-4', 'Dinajpur-5', 'Dinajpur-6'],
  'Gaibandha': ['Gaibandha-1', 'Gaibandha-2', 'Gaibandha-3', 'Gaibandha-4', 'Gaibandha-5'],
  'Kurigram': ['Kurigram-1', 'Kurigram-2', 'Kurigram-3', 'Kurigram-4'],
  'Lalmonirhat': ['Lalmonirhat-1', 'Lalmonirhat-2', 'Lalmonirhat-3'],
  'Nilphamari': ['Nilphamari-1', 'Nilphamari-2', 'Nilphamari-3', 'Nilphamari-4'],
  'Panchagarh': ['Panchagarh-1', 'Panchagarh-2'],
  'Rangpur': ['Rangpur-1', 'Rangpur-2', 'Rangpur-3', 'Rangpur-4', 'Rangpur-5', 'Rangpur-6'],
  'Thakurgaon': ['Thakurgaon-1', 'Thakurgaon-2', 'Thakurgaon-3'],
  // Sylhet Division
  'Habiganj': ['Habiganj-1', 'Habiganj-2', 'Habiganj-3', 'Habiganj-4'],
  'Moulvibazar': ['Moulvibazar-1', 'Moulvibazar-2', 'Moulvibazar-3', 'Moulvibazar-4'],
  'Sunamganj': ['Sunamganj-1', 'Sunamganj-2', 'Sunamganj-3', 'Sunamganj-4', 'Sunamganj-5'],
  'Sylhet': ['Sylhet-1', 'Sylhet-2', 'Sylhet-3', 'Sylhet-4', 'Sylhet-5', 'Sylhet-6']
};

export const districtToAdministrations = {
  // Barishal Division
  'Barguna': ['Amtali Municipality', 'Barguna Municipality', 'Betagi Municipality', 'Patharghata Municipality'],
  'Barishal': ['Barishal City Corporation', 'Bakerganj Municipality', 'Banaripara Municipality', 'Gournadi Municipality', 'Mehendiganj Municipality', 'Muladi Municipality', 'Wazirpur Municipality'],
  'Bhola': ['Bhola Municipality', 'Lalmohon Municipality', 'Char Fasson Municipality', 'Burhanuddin Municipality', 'Daulatkhan Municipality'],
  'Jhalokati': ['Jhalokati Municipality', 'Nalchity Municipality'],
  'Patuakhali': ['Patuakhali Municipality', 'Galachipa Municipality', 'Bauphal Municipality', 'Kolapara Municipality'],
  'Pirojpur': ['Pirojpur Municipality', 'Swarupkathi Municipality', 'Mathbaria Municipality'],
  // Chattogram Division
  'Bandarban': ['Bandarban Municipality', 'Lama Municipality'],
  'Brahmanbaria': ['Brahmanbaria Municipality', 'Akhaura Municipality', 'Ashuganj Municipality', 'Bancharampur Municipality', 'Kasba Municipality', 'Nabinagar Municipality'],
  'Chandpur': ['Chandpur Municipality', 'Hajiganj Municipality', 'Kachua Municipality', 'Matlab North Municipality', 'Matlab South Municipality', 'Shahrasti Municipality'],
  'Chattogram': ['Chittagong City Corporation', 'Akbarshah Municipality', 'Bayejid Bostami Municipality', 'Chandgaon Municipality', 'Double Mooring Municipality', 'Halishahar Municipality', 'Kotwali Municipality', 'Pahartali Municipality', 'Panchlaish Municipality', 'Patenga Municipality', 'Boalkhali Municipality', 'Raozan Municipality', 'Rangunia Municipality', 'Satkania Municipality'],
  'Cumilla': ['Cumilla City Corporation', 'Barura Municipality', 'Chandina Municipality', 'Chauddagram Municipality', 'Daudkandi Municipality', 'Debidwar Municipality', 'Homna Municipality', 'Laksam Municipality'],
  'Cox\'s Bazar': ['Cox\'s Bazar Municipality', 'Chakaria Municipality', 'Maheshkhali Municipality', 'Teknaf Municipality'],
  'Feni': ['Feni Municipality', 'Chhagalnaiya Municipality', 'Daganbhuiyan Municipality'],
  'Khagrachhari': ['Khagrachhari Municipality', 'Dighinala Municipality', 'Matiranga Municipality'],
  'Lakshmipur': ['Lakshmipur Municipality', 'Raipur Municipality', 'Ramganj Municipality'],
  'Noakhali': ['Noakhali Municipality', 'Begumganj Municipality', 'Chatkhil Municipality', 'Companiganj Municipality', 'Hatia Municipality'],
  'Rangamati': ['Rangamati Municipality'],
  // Dhaka Division
  'Dhaka': ['Dhaka North City Corporation', 'Dhaka South City Corporation', 'Savar Municipality', 'Dhamrai Municipality', 'Keraniganj Municipality'],
  'Faridpur': ['Faridpur Municipality', 'Bhanga Municipality', 'Boalmari Municipality', 'Nagarkanda Municipality'],
  'Gazipur': ['Gazipur City Corporation', 'Kaliakair Municipality', 'Sreepur Municipality'],
  'Gopalganj': ['Gopalganj Municipality', 'Kotalipara Municipality', 'Tungipara Municipality'],
  'Kishoreganj': ['Kishoreganj Municipality', 'Bajitpur Municipality', 'Bhairab Municipality', 'Hossainpur Municipality', 'Kuliarchar Municipality'],
  'Madaripur': ['Madaripur Municipality', 'Kalkini Municipality', 'Rajoir Municipality', 'Shibchar Municipality'],
  'Manikganj': ['Manikganj Municipality', 'Singair Municipality', 'Harirampur Municipality'],
  'Munshiganj': ['Munshiganj Municipality', 'Sreenagar Municipality', 'Tongibari Municipality'],
  'Narayanganj': ['Narayanganj City Corporation', 'Araihazar Municipality', 'Rupganj Municipality', 'Sonargaon Municipality'],
  'Narsingdi': ['Narsingdi Municipality', 'Monohardi Municipality', 'Shibpur Municipality'],
  'Rajbari': ['Rajbari Municipality', 'Pangsha Municipality'],
  'Shariatpur': ['Shariatpur Municipality', 'Naria Municipality', 'Jazeera Municipality'],
  'Tangail': ['Tangail Municipality', 'Basail Municipality', 'Bhuapur Municipality', 'Gopalpur Municipality', 'Kalihati Municipality', 'Mirzapur Municipality'],
  // Khulna Division
  'Bagerhat': ['Bagerhat Municipality', 'Mongla Municipality', 'Morrelganj Municipality'],
  'Chuadanga': ['Chuadanga Municipality', 'Alamdanga Municipality', 'Jibannagar Municipality'],
  'Jashore': ['Jashore Municipality', 'Abhaynagar Municipality', 'Bagherpara Municipality', 'Keshabpur Municipality', 'Manirampur Municipality'],
  'Jhenaidah': ['Jhenaidah Municipality', 'Harinakundu Municipality', 'Kaliganj Municipality', 'Kotchandpur Municipality'],
  'Khulna': ['Khulna City Corporation', 'Dighalia Municipality', 'Paikgachha Municipality'],
  'Kustia': ['Kushtia Municipality', 'Bheramara Municipality', 'Kumarkhali Municipality'],
  'Magura': ['Magura Municipality', 'Mohammadpur Municipality'],
  'Meherpur': ['Meherpur Municipality', 'Gangni Municipality'],
  'Narail': ['Narail Municipality', 'Kalia Municipality'],
  'Satkhira': ['Satkhira Municipality', 'Kalaroa Municipality', 'Shyamnagar Municipality'],
  // Mymensingh Division
  'Mymensingh': ['Mymensingh City Corporation', 'Bhaluka Municipality', 'Gafargaon Municipality', 'Muktagacha Municipality', 'Trishal Municipality'],
  'Netrokona': ['Netrokona Municipality', 'Durgapur Municipality', 'Kendua Municipality'],
  'Jamalpur': ['Jamalpur Municipality', 'Islampur Municipality', 'Melandaha Municipality'],
  'Sherpur': ['Sherpur Municipality', 'Nakla Municipality'],
  // Rajshahi Division
  'Bagura': ['Bogura City Corporation', 'Dhunat Municipality', 'Gabtali Municipality', 'Shibganj Municipality'],
  'Chapainawabganj': ['Chapainawabganj Municipality', 'Gomastapur Municipality', 'Shibganj Municipality'],
  'Joypurhat': ['Joypurhat Municipality', 'Akkelpur Municipality', 'Panchbibi Municipality'],
  'Naogaon': ['Naogaon Municipality', 'Dhamoirhat Municipality', 'Patnitala Municipality'],
  'Natore': ['Natore Municipality', 'Singra Municipality', 'Bagatipara Municipality'],
  'Pabna': ['Pabna Municipality', 'Bera Municipality', 'Ishwardi Municipality'],
  'Rajshahi': ['Rajshahi City Corporation', 'Bagha Municipality', 'Puthia Municipality'],
  'Sirajganj': ['Sirajganj Municipality', 'Shahjadpur Municipality', 'Ullapara Municipality'],
  // Rangpur Division
  'Dinajpur': ['Dinajpur Municipality', 'Birampur Municipality', 'Parbatipur Municipality'],
  'Gaibandha': ['Gaibandha Municipality', 'Gobindaganj Municipality', 'Sundarganj Municipality'],
  'Kurigram': ['Kurigram Municipality', 'Nageshwari Municipality', 'Ulipur Municipality'],
  'Lalmonirhat': ['Lalmonirhat Municipality', 'Patgram Municipality'],
  'Nilphamari': ['Nilphamari Municipality', 'Saidpur Municipality', 'Domar Municipality'],
  'Panchagarh': ['Panchagarh Municipality', 'Debiganj Municipality'],
  'Rangpur': ['Rangpur City Corporation', 'Badarganj Municipality', 'Pirganj Municipality'],
  'Thakurgaon': ['Thakurgaon Municipality', 'Ranisankail Municipality'],
  // Sylhet Division
  'Habiganj': ['Habiganj Municipality', 'Chunarughat Municipality', 'Madhabpur Municipality'],
  'Moulvibazar': ['Moulvibazar Municipality', 'Kulaura Municipality', 'Sreemongal Municipality'],
  'Sunamganj': ['Sunamganj Municipality', 'Chhatak Municipality', 'Jagannathpur Municipality'],
  'Sylhet': ['Sylhet City Corporation', 'Beanibazar Municipality', 'Golapganj Municipality']
};

export const districtToThanas = {
  // Barishal Division
  'Barguna': ['Amtali', 'Bamna', 'Barguna Sadar', 'Betagi', 'Patharghata', 'Taltali'],
  'Barishal': ['Agailjhara', 'Babuganj', 'Bakerganj', 'Banaripara', 'Barishal Sadar', 'Gournadi', 'Hizla', 'Mehendiganj', 'Muladi', 'Wazirpur'],
  'Bhola': ['Bhola Sadar', 'Burhanuddin', 'Char Fasson', 'Daulatkhan', 'Lalmohan', 'Manpura', 'Tazumuddin'],
  'Jhalokati': ['Jhalokati Sadar', 'Kathalia', 'Nalchity', 'Rajapur'],
  'Patuakhali': ['Bauphal', 'Dashmina', 'Dumki', 'Galachipa', 'Kalapara', 'Mirzaganj', 'Patuakhali Sadar', 'Rangabali'],
  'Pirojpur': ['Bhandaria', 'Kawkhali', 'Mathbaria', 'Nazirpur', 'Pirojpur Sadar', 'Swarupkathi', 'Zianagar'],
  // Chattogram Division
  'Bandarban': ['Alikadam', 'Bandarban Sadar', 'Lama', 'Naikhongchhari', 'Rowangchhari', 'Ruma', 'Thanchi'],
  'Brahmanbaria': ['Akhaura', 'Ashuganj', 'Bancharampur', 'Brahmanbaria Sadar', 'Kasba', 'Nabinagar', 'Nasirnagar', 'Sarail'],
  'Chandpur': ['Chandpur Sadar', 'Faridganj', 'Haimchar', 'Hajiganj', 'Kachua', 'Matlab North', 'Matlab South', 'Shahrasti'],
  'Chattogram': ['Anwara', 'Banshkhali', 'Boalkhali', 'Chandanaish', 'Fatikchhari', 'Hathazari', 'Lohagara', 'Mirsharai', 'Patiya', 'Rangunia', 'Raozan', 'Sadarghat', 'Sandwip', 'Satkania', 'Sitakunda'],
  'Cumilla': ['Barura', 'Brahmanpara', 'Burichong', 'Comilla Sadar', 'Comilla Sadar Dakshin', 'Chandina', 'Chauddagram', 'Daudkandi', 'Debidwar', 'Homna', 'Laksam', 'Lalmai', 'Monohorganj', 'Meghna', 'Muradnagar', 'Nangalkot', 'Titas'],
  'Cox\'s Bazar': ['Chakaria', 'Cox\'s Bazar Sadar', 'Kutubdia', 'Maheshkhali', 'Ramu', 'Ukhia', 'Pekua', 'Eidgaon'],
  'Feni': ['Chhagalnaiya', 'Daganbhuiyan', 'Feni Sadar', 'Fulgazi', 'Parshuram', 'Sonagazi'],
  'Khagrachhari': ['Dighinala', 'Khagrachhari Sadar', 'Lakshmichhari', 'Mahalchhari', 'Manikchhari', 'Matiranga', 'Panchhari', 'Ramgarh', 'Guimara'],
  'Lakshmipur': ['Kamalnagar', 'Lakshmipur Sadar', 'Raipur', 'Ramganj', 'Ramgati'],
  'Noakhali': ['Begumganj', 'Bhashanchar', 'Chatkhil', 'Companiganj', 'Hatia', 'Kabirhat', 'Noakhali Sadar', 'Senbagh', 'Sonaimuri', 'Subornochar'],
  'Rangamati': ['Bagaichhari', 'Belaichhari', 'Barkal', 'Juraichhari', 'Kaptai', 'Kaukhali', 'Langadu', 'Naniarchar', 'Rajasthali', 'Rangamati Sadar'],
  // Dhaka Division
  'Dhaka': ['Adabor', 'Badda', 'Banani', 'Gulshan', 'Bhashantek', 'Bimanbandar', 'Cantonment', 'Darussalam', 'Hatirjheel', 'Kafrul', 'Khilkhet', 'Mirpur', 'Mohammadpur', 'Pallabi', 'Rampura', 'Rupnagar', 'Shah Ali', 'Sher-E-Bangla Nagar', 'Shilpanchal', 'Tejgaon', 'Turag', 'Uttara-East', 'Uttara-West', 'Uttarkhan', 'Vatara', 'Bangshal', 'Chawkbazar', 'Demra', 'Dhanmondi', 'Gandaria', 'Hazaribagh', 'Jatrabari', 'Kadamtali', 'Kalabagan', 'Khilgaon', 'Kotwali', 'Lalbagh', 'Motijheel', 'Mugda', 'Paltan', 'Ramna', 'Sabujbagh', 'Shahbag', 'Shahjahanpur', 'Shampur', 'Sutrapur', 'Wari', 'Dhamrai', 'Dohar', 'Keraniganj', 'Nawabganj', 'Savar'],
  'Faridpur': ['Alfadanga', 'Bhanga', 'Boalmari', 'Charbhadrasan', 'Faridpur Sadar', 'Madhukhali', 'Nagarkanda', 'Sadarpur', 'Saltha'],
  'Gazipur': ['Gazipur Sadar', 'Kaliakair', 'Kaliganj', 'Kapasia', 'Sreepur'],
  'Gopalganj': ['Gopalganj Sadar', 'Kashiani', 'Kotalipara', 'Muksudpur', 'Tungipara'],
  'Kishoreganj': ['Austagram', 'Bajitpur', 'Bhairab', 'Hossainpur', 'Itna', 'Karimganj', 'Katiadi', 'Kishoreganj Sadar', 'Kuliarchar', 'Mithamain', 'Nikili', 'Pakundia', 'Tarail'],
  'Madaripur': ['Dasar', 'Kalkini', 'Madaripur Sadar', 'Rajoir', 'Shibchar'],
  'Manikganj': ['Daulatpur', 'Ghior', 'Harirampur', 'Manikganj Sadar', 'Sarutia', 'Shivalaya', 'Singair'],
  'Munshiganj': ['Gazaria', 'Lohajang', 'Munshiganj Sadar', 'Sirajdikhan', 'Sreenagar', 'Tongibari'],
  'Narayanganj': ['Araihazar', 'Baidder Bazar', 'Bandar', 'Fatullah', 'Narayanganj Sadar', 'Rupganj', 'Siddhirganj', 'Sonargaon'],
  'Narsingdi': ['Belabo', 'Monohardi', 'Narsingdi Sadar', 'Palash', 'Raipura', 'Shibpur'],
  'Rajbari': ['Baliakandi', 'Goalanda', 'Kalukhali', 'Pangsha', 'Rajbari Sadar'],
  'Shariatpur': ['Bhedarganj', 'Damudya', 'Gosairhat', 'Jazeera', 'Naria', 'Shariatpur Sadar', 'Shakhipur'],
  'Tangail': ['Basail', 'Bhuapur', 'Delduar', 'Dhanbari', 'Ghatail', 'Gopalpur', 'Kalihati', 'Madhupur', 'Mirzapur', 'Nagarpur', 'Shakhipur', 'Tangail Sadar'],
  // Khulna Division
  'Bagerhat': ['Bagerhat Sadar', 'Chitalmari', 'Fakirhat', 'Kachua', 'Mollahat', 'Mongla', 'Morrelganj', 'Sarankhola'],
  'Chuadanga': ['Alamdanga', 'Chuadanga Sadar', 'Damurhuda', 'Darsana', 'Jibannagar'],
  'Jashore': ['Abhaynagar', 'Bagherpara', 'Chaugachha', 'Jashore Sadar', 'Jhikargacha', 'Keshabpur', 'Manirampur', 'Sharsha'],
  'Jhenaidah': ['Harinakundu', 'Jhenaidah Sadar', 'Kaliganj', 'Kotchandpur', 'Maheshpur', 'Shailkupa'],
  'Khulna': ['Batiaghata', 'Dacope', 'Dighalia', 'Dumuria', 'Koyra', 'Paikgachha', 'Phultala', 'Rupsha', 'Terokhada'],
  'Kustia': ['Bheramara', 'Daulatpur', 'Khoksa', 'Kumarkhali', 'Kushtia Sadar'],
  'Magura': ['Magura Sadar', 'Mohammadpur', 'Shalikha', 'Sreepur'],
  'Meherpur': ['Meherpur Sadar', 'Mujibnagar', 'Gangni'],
  'Narail': ['Lohagara', 'Kalia', 'Narail Sadar'],
  'Satkhira': ['Assasuni', 'Debhata', 'Kalaroa', 'Kaliganj', 'Satkhira Sadar', 'Shyamnagar', 'Tala'],
  // Mymensingh Division
  'Mymensingh': ['Bhaluka', 'Dhobaura', 'Fulbaria', 'Gafargaon', 'Gauripur', 'Haluaghat', 'Ishwarganj', 'Muktagacha', 'Mymensingh Sadar', 'Nandail', 'Phulpur', 'Tarakanda', 'Trishal'],
  'Netrokona': ['Atpara', 'Barhatta', 'Durgapur', 'Kendua', 'Khaliajuri', 'Kalmakanda', 'Madon', 'Mohangonj', 'Netrokona Sadar', 'Purbodhola'],
  'Jamalpur': ['Bakshiganj', 'Dewanganj', 'Islampur', 'Jamalpur Sadar', 'Madarganj', 'Melandaha', 'Sharishabari'],
  'Sherpur': ['Jhenaigati', 'Nakla', 'Nalitabari', 'Sherpur Sadar', 'Sreebardi'],
  // Rajshahi Division
  'Bagura': ['Adamdighi', 'Bagura Sadar', 'Dhunat', 'Dupchanchia', 'Gabtali', 'Kahaloo', 'Nandigram', 'Sahajanpur', 'Sariakandi', 'Sherpur', 'Shibganj', 'Sonatala'],
  'Chapainawabganj': ['Bholahat', 'Chapainawabganj Sadar', 'Gomastapur', 'Shibganj'],
  'Joypurhat': ['Akkelpur', 'Joypurhat Sadar', 'Kalai', 'Khetlal', 'Panchbibi'],
  'Naogaon': ['Atrai', 'Badalgachhi', 'Dhamoirhat', 'Manda', 'Mohadevpur', 'Naogaon Sadar', 'Niamatpur', 'Patnitala', 'Porsha', 'Raninagar', 'Sapahar'],
  'Natore': ['Bagatipara', 'Baraigram', 'Gurudaspur', 'Lalpur', 'Natore Sadar', 'Naldanga', 'Singra'],
  'Pabna': ['Atgharia', 'Bera', 'Bhangura', 'Chatmohar', 'Faridpur', 'Ishwardi', 'Pabna Sadar', 'Santhia', 'Suzanagar'],
  'Rajshahi': ['Bagmara', 'Bagha', 'Boalia', 'Charghat', 'Durgapur', 'Godagari', 'Mohanpur', 'Motihar', 'Paba', 'Puthia', 'Rajpara', 'Shah Makhdum', 'Tanore'],
  'Sirajganj': ['Belkuchi', 'Chauhali', 'Kamarkhanda', 'Kazipur', 'Raiganj', 'Shahjadpur', 'Sirajganj Sadar', 'Tarash', 'Ullapara'],
  // Rangpur Division
  'Dinajpur': ['Biral', 'Birampur', 'Birganj', 'Bochaganj', 'Chirirbandar', 'Dinajpur Sadar', 'Ghoraghat', 'Hakimpur', 'Kaharole', 'Khansama', 'Nawabganj', 'Parbatipur', 'Phulbari'],
  'Gaibandha': ['Fulchhari', 'Gaibandha Sadar', 'Gobindaganj', 'Palashbari', 'Sadullapur', 'Saghata', 'Sundarganj'],
  'Kurigram': ['Bhurungamari', 'Char Rajibpur', 'Chilmari', 'Kurigram Sadar', 'Nageshwari', 'Phulbari', 'Rajarhat', 'Rowmari', 'Ulipur'],
  'Lalmonirhat': ['Aditmari', 'Hatibandha', 'Kaliganj', 'Lalmonirhat Sadar', 'Patgram'],
  'Nilphamari': ['Dimla', 'Domar', 'Jaldhaka', 'Kishoreganj', 'Nilphamari Sadar', 'Saidpur'],
  'Panchagarh': ['Atwari', 'Boda', 'Debiganj', 'Panchagarh Sadar', 'Tetulia'],
  'Rangpur': ['Badarganj', 'Gangachhara', 'Kaunia', 'Mithapukur', 'Pirgachha', 'Pirganj', 'Rangpur Sadar', 'Taraganj'],
  'Thakurgaon': ['Baliadangi', 'Haripur', 'Pirganj', 'Ranisankail', 'Thakurgaon Sadar'],
  // Sylhet Division
  'Habiganj': ['Azmiriganj', 'Bahubal', 'Baniachang', 'Chunarughat', 'Habiganj Sadar', 'Lakhai', 'Madhabpur', 'Nabiganj', 'Shayestaganj'],
  'Moulvibazar': ['Barlekha', 'Juri', 'Kamalganj', 'Kulaura', 'Moulvibazar Sadar', 'Rajnagar', 'Sreemongal'],
  'Sunamganj': ['Bishwamvarpur', 'Chhatak', 'Derai', 'Dharampasha', 'Dowarabazar', 'Jagannathpur', 'Jamalganj', 'Shantiganj-South Sunamganj', 'Sulla', 'Sunamganj Sadar', 'Tahirpur'],
  'Sylhet': ['Balaganj', 'Beanibazar', 'Bimanbondar', 'Bishwanath', 'Companiganj', 'Fenchuganj', 'Golapganj', 'Gowainghat', 'Jaintiapur', 'Jalalabad', 'Kanaighat', 'Kotwali', 'Maglabazar', 'Osmani Nagar', 'Shahporan', 'South Shurma', 'Sylhet Sadar', 'Zakiganj']
};

// Fraud categories based on database schema
export const fraudCategories = [
  { value: 'romance', label: 'Romance Scam' },
  { value: 'investment', label: 'Investment Fraud' },
  { value: 'online-shopping', label: 'Online Shopping Scam' },
  { value: 'banking', label: 'Banking Fraud' },
  { value: 'job', label: 'Job Scam' },
  { value: 'lottery', label: 'Lottery Scam' },
  { value: 'tech-support', label: 'Tech Support Scam' },
  { value: 'other', label: 'Other' }
];

// Communication mediums based on database schema
export const communicationMediums = [
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'facebook', label: 'Facebook' },
  { value: 'phone-call', label: 'Phone Call' },
  { value: 'sms', label: 'SMS' },
  { value: 'telegram', label: 'Telegram' },
  { value: 'imo', label: 'IMO' },
  { value: 'viber', label: 'Viber' }
];

// Transaction methods based on database schema
export const transactionMethods = [
  { value: 'bkash', label: 'bKash' },
  { value: 'nagad', label: 'Nagad' },
  { value: 'rocket', label: 'Rocket' },
  { value: 'upay', label: 'Upay' },
  { value: 'bank', label: 'Bank Transfer' },
  { value: 'cash', label: 'Cash' },
  { value: 'mobile-banking', label: 'Mobile Banking' }
];

// Urgency levels based on database schema
export const urgencyLevels = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' }
];

// Evidence quality levels based on database schema
export const evidenceQualityLevels = [
  { value: 'weak', label: 'Weak' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'strong', label: 'Strong' }
];

// Report status options based on database schema
export const reportStatuses = [
  { value: 'pending', label: 'Pending' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' }
];